import type { ReactNode } from "react";
import { createContext, useContext } from "react";

import { useMessengerHook } from "./hook";
import type { HookReturn } from "./types";

export const MessengerContext = createContext<HookReturn>({
  isConnectionEstablished: false,
  sendDataMessage: () => {},
  getMessage: () => {},
  subscribeToMessageReceived: () => {},
  subscribeToDataReceived: () => {},
  subscribeToRedirectRequested: () => {},
});

export const MessengerProvider = ({ children }: { children: ReactNode | ReactNode[] }) => {
  const value = useMessengerHook();

  return <MessengerContext.Provider value={value}>{children}</MessengerContext.Provider>;
};

export const useMessenger = () => useContext(MessengerContext);
